import _ from 'underscore';
import React from 'react';
import { Field } from '@fluentui/react-components';
import { ValidationGroup, withErrorMessage } from '@bingads-webui-react/validation';
import { IValidationProps, IWithErrorFieldProps } from './types';

export function withErrorField<P>(Component: React.ComponentType<P & { validationProps: IValidationProps }>): React.ComponentType<P & IWithErrorFieldProps> {
  class FieldWrapper extends React.PureComponent<P & IWithErrorFieldProps> {
    static defaultProps: Partial<IWithErrorFieldProps> = {
      validationProps: {
        messages: [],
      },
      fieldProps: undefined,
    };

    render() {
      const { fieldProps, ...restProps } = this.props;
      const {
        messages,
      } = this.props.validationProps!;

      const validationMessage = messages && messages.join(',');

      return (
        <Field validationMessage={messages && !_.isEmpty(messages) && validationMessage} {...fieldProps}>
          <Component
            {...(restProps as P)}
            validationProps={this.props.validationProps!}
          />
        </Field>
      );
    }
  }
  return withErrorMessage(FieldWrapper);
}

export const ValidatedField = withErrorField<React.PropsWithChildren<unknown>>(ValidationGroup);
